import { Component, HostListener, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { DisplayMode, OrientationService } from 'src/app/services/orientation/orientation.service';

@Component({
  selector: 'app-site-footer',
  templateUrl: './site-footer.component.html'
})
export class SiteFooterComponent implements OnInit {

  protected displayMode: DisplayMode; 

  constructor(
    private readonly orientationService: OrientationService,
  ) {

  }

  ngOnInit(): void {
    this.orientationService.displayMode$.subscribe((mode) => {
      this.displayMode = mode;
    });
    this.orientationService.handleOrientationChange();
  }

}
